<template>
<div>
 <div class="card">
    <div class="card-header">Mensajes</div>
  
 <b-tabs>
 <b-tab title="Enviar Mensaje">
      <div class="card-body">
          <div class="form-group row">
              <div class="col-4">

                  <input id="deudores" v-model="filtro" type="radio" value="deudores" @click="filtrar" />
                   <label for="deudores">Deudores</label>
                    </div>
                    <div class="col-4">
                <input id="todos" v-model="filtro" type="radio" value="todos" @click="filtrar" />
                 <label for="todos">Todos</label>
            
              </div>
          </div>
         

          
            <input id="allSelected" type="checkbox" @click="selectAll" v-model="allSelected">
             <label for="todos">Seleccionar toda la lista</label>
                <br>
                 <div class="form-group row">
              <div class="col-4">
                  <button class="btn btn-info" @click="sendMessages">
                       <i class="fa fa-send"></i>
                       Enviar
                  </button>
              </div>
              </div>
              <h2 v-if="espere">Descargando lista. Espere...</h2>
               
  <div v-for="(obj,index) in lista_clientes" :key="index">
    <label class="custom-control custom-checkbox" >
        <input type="checkbox" class="custom-control-input" :value="obj" @click="select" v-model="selectedAddOns" >
        <span class="custom-control-indicator"></span>
        <span class="custom-control-description">{{(index+1)+".-"+obj.nombre+" "+obj.apellido}}</span>
    </label>
       </div>
    
       
      </div>

 </b-tab>
     <!-- <b-tab title="Plantilla de Mensaje" v-if="permiso==1 || permiso==3">
 <div class="card-body">
          <div class="form-group row">
                <div class="col-md-10">
              <label for="exampleFormControlTextarea1">Mensaje</label>
    <textarea class="form-control" v-model="message.mensaje" id="exampleFormControlTextarea1" rows="3"></textarea>
    </div>
          </div>
          
          <div class="form-group row">
               <div class="col-md-4">
              <button class="btn btn-primary" @click="saveMesage">
                <i class="fa fa-save"></i>
                Guardar
              </button>
               
            </div>
          </div>

 </div>
      </b-tab>-->
 </b-tabs>
 </div>
 
</div>

</template>
<script>
import { url } from "../main.js";
export default {
     data() {
    return {
         allSelected: false,
       filtro:'deudores',
       espere:false,
        selectedAddOns:[],
        lista_clientes:[],
        lista_mensajes:[],
        permiso:0,
        message:{
            idmensaje:0,
            mensaje:''
        },
        mensaje:{
            idfacebook:0,
            mensaje:''

        }

    }
     },mounted()
     { this.permiso = localStorage.getItem("permission");
         this.get_clientes_deudores();
        // this.get_mensaje();

     },  methods: {

         saveMesage(){
               this.axios
          .post(url + "apiMensajes.php/save_template",this.message)
          .then(respuesta=> {
              console.log(respuesta)
             if (respuesta.data.status === 200) {
            
            this.$swal(respuesta.data.msg);

             }

          });

         },
         get_mensaje(){
this.axios
          .get(url + "apiMensajes.php/get_template")
          .then(respuesta=> {
              console.log(respuesta)
              this.message=respuesta.data
            

          });
         },

         get_clientes(){
           this.espere=true;
               this.axios
          .get(url + "apiMensajes.php/get_clientes")
          .then(respuesta=> {
              console.log(respuesta)
              this.lista_clientes=respuesta.data
              this.selectAll();
                         this.espere=false;


          });
         },
           get_clientes_deudores(){
                        this.espere=true;

               this.axios
          .get(url + "apiMensajes.php/get_clientes_deudores")
          .then(respuesta=> {
              console.log(respuesta)
              this.lista_clientes=respuesta.data
              this.selectAll();
           this.espere=false;

          });
         },
           selectAll() {

            this.select= [];

            if (this.allSelected) {
              this.lista_clientes.forEach(element => {
                 this.select.push(element);
              });
              this.selectedAddOns=this.select
                
            }else{
              for(var i=0;i<this.lista_clientes.length;i++)
              {
                 this.select.splice(i, 1);
              }
              this.selectedAddOns=this.select
            }

        },
        select() {
            this.allSelected = false;
            this.selectedAddOns=[];
        },
        filtrar(){
          if(this.filtro=='todos')
          {
            this.get_clientes()
          }

          if(this.filtro=='deudores')
          {
            this.get_clientes_deudores()
          }

        },
        sendMessages()
        {
			if(this.filtro=='todos')
            {
				this.selectedAddOns.forEach(element => {
               
              
                

			   this.lista_mensajes.push(Object.assign({}, element))
			 
		 });
		 console.log(this.lista_mensajes)
		 var enviar={};
		 enviar.lista_mensajes=this.lista_mensajes;
		 console.log(JSON.stringify(enviar));
		  this.axios
	   .post(url + "apiMensajes.php/send_messages_promo",enviar)
	   .then(respuesta=> {
		   console.log(respuesta)
		 this.lista_mensajes=[];
			 this.$swal("¡Mensajes Enviados!");

	   });
			}
			if(this.filtro=='deudores')
			{
            this.selectedAddOns.forEach(element => {
               
              
                

                  this.lista_mensajes.push(Object.assign({}, element))
                
            });
			console.log(this.lista_mensajes)
			var enviar={};
			enviar.lista_mensajes=this.lista_mensajes;
			console.log(JSON.stringify(enviar));
             this.axios
          .post(url + "apiMensajes.php/send_messages",enviar)
          .then(respuesta=> {
              console.log(respuesta)
            this.lista_mensajes=[];
                this.$swal("¡Mensajes Enviados!");

          });
		}
        }
     }
}
</script>


// WEBPACK FOOTER //
// src/views/mensajes.vue